/*******************************************************************************
OUTPUT SANITIZED HTML
This is a custom plugin written to replace jQuery's built-in html() method with something
that's more resistant to XSS attacks when user-generated data is added to the page.
*******************************************************************************/

import { sanitize } from '../../../lib/_dompurify/purify';

export default function addPluginSafeHTML() {

    // Sanitize the HTML string before sending it through jQuery's .html() method
    jQuery.fn.safehtml = function safeHTML(htmlString) {
        const safeHTMLString = sanitize(htmlString, { SAFE_FOR_JQUERY: true });
        $(this).html(safeHTMLString);
        return this;
    };
}
